import * as Scrivito from "scrivito";
import { formatDateRange } from "../../utils/formatDateRange";
import { getFormatLabel } from "./_trainingUtils";
import { AvailabilityBadge } from "./AvailablityBadge";
import { createTranslator } from "../../utils/translate";
import de from "./de.json";
import en from "./en.json";

const translations = { de, en };

const InfoRow = ({ label, children }) => (
  <div className="mb-3">
    <div className="text-muted small text-uppercase fw-semibold">{label}</div>
    <div>{children}</div>
  </div>
);

const TrainingCourseInfo = ({ page, language }) => {
  const t = createTranslator(language, translations);
  const startDate = page.get("startDate");
  const endDate = page.get("endDate");
  const contactEmail = page.get("contactEmail");
  const title = page.get("title");

  const mailtoHref = contactEmail
    ? `mailto:${contactEmail}?subject=${encodeURIComponent(
        `${t("registrationSubject")} ${title}`
      )}&body="Liebes Weiterbildungsteam, hiermit melde ich mich für den Kurs '${title}' an."`
    : null;

  return (
    <div className="bg-white p-3 rounded training-course-info">
      <h3 className="text-blue fw-bold mb-4">{t("courseInfo")}</h3>

      {startDate && (
        <InfoRow label={t("dateLabel")}>
          {formatDateRange(startDate, endDate, { locale: language })}
        </InfoRow>
      )}

      {page.get("format") && (
        <InfoRow label={t("formatLabel")}>
          {getFormatLabel(page.get("format"), language)}
        </InfoRow>
      )}

      {page.get("location") && (
        <InfoRow label={t("locationLabel")}>{page.get("location")}</InfoRow>
      )}

      {page.get("speaker") && (
        <InfoRow label={t("speakerLabel")}>{page.get("speaker")}</InfoRow>
      )}

      <InfoRow label={t("freeSlotsLabel")}>
        <AvailabilityBadge course={page} language={language} />
      </InfoRow>

      <InfoRow label={t("appointmentsLabel")}>
        <Scrivito.ContentTag content={page} attribute="appointments" />
      </InfoRow>

      {page.get("transferSupport") && (
        <InfoRow label={t("transferSupportLabel")}>
          {page.get("transferSupport")}
        </InfoRow>
      )}

      {mailtoHref && (
        <a href={mailtoHref} className="btn bg-yellow w-100 mt-2">
          {t("register")}
        </a>
      )}
    </div>
  );
};

export default TrainingCourseInfo;
